function lngamm(z)
// Reference: "Lanczos, C. 'A precision approximation 
// of the gamma function', J. SIAM Numer. Anal., B, 1, 86-96, 1964."
// Translation of  Alan Miller's FORTRAN-implementation
// See http://lib.stat.cmu.edu/apstat/245
{
  var x = 0;
  x += 0.1659470187408462e-06 / (z + 7);
  x += 0.9934937113930748e-05 / (z + 6);
  x -= 0.1385710331296526 / (z + 5);
  x += 12.50734324009056 / (z + 4);
  x -= 176.6150291498386 / (z + 3);
  x += 771.3234287757674 / (z + 2);
  x -= 1259.139216722289 / (z + 1);
  x += 676.5203681218835 / (z);
  x += 0.9999999999995183;
  return (Math.log(x) - 5.58106146679532777 - z + (z - 0.5) * Math.log(z + 6.5));
}

function lnfact(n) {
  if (n <= 1) return (0);
  return (lngamm(n + 1));
}

function lnbico(n, k) {
  return (lnfact(n) - lnfact(k) - lnfact(n - k));
}

function hyper_323(n11, n1_, n_1, n) {
  return (Math.exp(lnbico(n1_, n11) + lnbico(n - n1_, n_1 - n11) - lnbico(n, n_1)));
}

var sn11, sn1_, sn_1, sn, sprob;
function hyper(n11) {
  return (hyper0(n11, 0, 0, 0));
}

function hyper0(n11i, n1_i, n_1i, ni) {
  if (!(n1_i | n_1i | ni)) {
    if (!(n11i % 10 == 0)) {
      if (n11i == sn11 + 1) {
        sprob *= ((sn1_ - sn11) / (n11i)) * ((sn_1 - sn11) / (n11i + sn - sn1_ - sn_1));
        sn11 = n11i;
        return sprob;
      }
      if (n11i == sn11 - 1) {
        sprob *= ((sn11) / (sn1_ - n11i)) * ((sn11 + sn - sn1_ - sn_1) / (sn_1 - n11i));
        sn11 = n11i;
        return sprob;
      }
    }
    sn11 = n11i;
  }
  else {
    sn11 = n11i;
    sn1_ = n1_i;
    sn_1 = n_1i;
    sn = ni;
  }
  sprob = hyper_323(sn11, sn1_, sn_1, sn);
  return sprob;
}

var sleft, sright, sless, slarg;
export const exact = (n11, n1_, n_1, n) => {
  var p, i, j, prob;
  var max = n1_;
  if (n_1 < max) max = n_1;
  var min = n1_ + n_1 - n;
  if (min < 0) min = 0;
  if (min == max) {
    sless = 1;
    sright = 1;
    sleft = 1;
    slarg = 1;
    return 1;
  }
  prob = hyper0(n11, n1_, n_1, n);
  sleft = 0;
  p = hyper(min);
  for (i = min + 1; p < 0.99999999 * prob; i++) {
    sleft += p;
    p = hyper(i);
  }
  i--;
  if (p < 1.00000001 * prob) sleft += p;
  else i--;
  sright = 0;
  p = hyper(max);
  for (j = max - 1; p < 0.99999999 * prob; j--) {
    sright += p;
    p = hyper(j);
  }
  j++;
  if (p < 1.00000001 * prob) sright += p;
  else j++;
  if (Math.abs(i - n11) < Math.abs(j - n11)) {
    sless = sleft;
    slarg = 1 - sleft + prob;
  }
  else {
    sless = 1 - sright + prob;
    slarg = sright;
  }
  return prob;
}

// pnorm function adapted from https://rangevoting.org/NHack.html
/** * @(#)pnorm.js * * Copyright (c) 2000 by Sundar Dorai-Raj
  * * @author Sundar Dorai-Raj
  * * Email: sdoraira@vt.edu
  * * This program is free software; you can redistribute it and/or
  * * modify it under the terms of the GNU General Public License 
  * * as published by the Free Software Foundation; either version 2 
  * * of the License, or (at your option) any later version, 
  * * provided that any use properly credits the author. 
  * * This program is distributed in the hope that it will be useful,
  * * but WITHOUT ANY WARRANTY; without even the implied warranty of
  * * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  * * GNU General Public License for more details at http://www.gnu.org * * */

// "Applied Statistics Algorithms" (1985)
// P. Griffiths and I. D. Hill, editors

function pnorm(z) {
  // Algorithm AS66 Applied Statistics (1973) vol22 no.3
  // Computes P(Z<z)
  // var z = parseFloat(z);
  // var upper=(form.upper[0].checked ? true:false); 
  var upper = false;
  const ltone = 7.0;
  const utzero = 18.66;
  const con = 1.28;
  const a1 = 0.398942280444;
  const a2 = 0.399903438504;
  const a3 = 5.75885480458;
  const a4 = 29.8213557808;
  const a5 = 2.62433121679;
  const a6 = 48.6959930692;
  const a7 = 5.92885724438;
  const b1 = 0.398942280385;
  const b2 = 3.8052e-8;
  const b3 = 1.00000615302;
  const b4 = 3.98064794e-4;
  const b5 = 1.986153813664;
  const b6 = 0.151679116635;
  const b7 = 5.29330324926;
  const b8 = 4.8385912808;
  const b9 = 15.1508972451;
  const b10 = 0.742380924027;
  const b11 = 30.789933034;
  const b12 = 3.99019417011;

  if (z < 0) {
    upper = !upper;
    z = -z;
  }
  if (z <= ltone || upper && z <= utzero) {
    const y = 0.5 * z * z;
    if (z > con) {
      var alnorm = b1 * Math.exp(-y) / (z - b2 + b3 / (z + b4 + b5 / (z - b6 + b7 / (z + b8 - b9 / (z + b10 + b11 / (z + b12))))));
    }
    else {
      alnorm = 0.5 - z * (a1 - a2 * y / (y + a3 - a4 / (y + a5 + a6 / (y + a7))));
    }
  }
  else {
    alnorm = 0;
  }
  if (!upper) alnorm = 1 - alnorm;
  return (alnorm);
}


export const calculatePvalueFromZ = (Z) => {
  const z = (0 - Math.abs(Z));
  var p = pnorm(z) * 2;
  return isNaN(p) ? -1 : p;
}

